import { Attr, BelongsTo, Model } from "spraypaint";

import type { InsightsLandingPageItemTargetClass } from "shared/modules/Insights/types";
import { ApplicationRecord } from "shared/services/spraypaint";

@Model()
class InsightsArchived extends ApplicationRecord {
  static jsonapiType = "insights_archived";

  static type = "insights_archived";

  @Attr() archivedAt: string;

  @Attr() organisationId: number;

  @Attr() organisationTeamId: number;

  @BelongsTo() target: InsightsLandingPageItemTargetClass;

  @Attr() targetId: number;

  @Attr() targetType: string;

  @Attr() userId: number;
}

export default InsightsArchived;
